import { HttpClient,  HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable,  map } from 'rxjs';
import { RoleViewService } from './role-view.service';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
}

const WORKDAY_ID_PARAM = '?workDayId=';
@Injectable({
  providedIn: 'root'
})
export class ManageProjectService {
  private _selectedProject: any;
  superAdminUrl = environment?.baseApiUrl + environment?.superAdminApiPath;
  userUuid = '';

  constructor(private readonly http: HttpClient,private readonly roleViewService:RoleViewService) { 
      this.roleViewService.getUserName$().subscribe(uuid => {
        this.userUuid = uuid;
      }); }

  fetchProject(): Observable<any> {
    const url = `${this.superAdminUrl}fetchProjectHandler${environment?.proxy}`;
    return this.http.get(url, httpOptions)
      .pipe(map((response: any) => response));
  }

  deleteRestoreProject(_workDayId: string,request: any): Observable<any> {
    const url = `${this.superAdminUrl}dltAndRestoreProjectHandler${environment?.proxy}${WORKDAY_ID_PARAM}${this.userUuid}`;
    return this.http.post(url, request, httpOptions)
      .pipe(map((response: any) => response));
  }

  updateProject(_workDayId: string, request: any): Observable<any> {
    const url = `${this.superAdminUrl}updateProjectHandler${environment?.proxy}${WORKDAY_ID_PARAM}${this.userUuid}`;
    return this.http.post(url, request, httpOptions)
      .pipe(map((response: any) => response));
  }

  createProject(_workDayId: string, request: any): Observable<any> {
    const url = `${this.superAdminUrl}createProjectHandler${environment?.proxy}${WORKDAY_ID_PARAM}${this.userUuid}`;
    return this.http.post(url, request, httpOptions)
      .pipe(map((response: any) => response));
  }

  setFetchProject(projectForm: any){
    this._selectedProject = projectForm;
    console.info("project", projectForm)
  }
  getFetchProject(): any {
    return this._selectedProject;
  }
  
}
